import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'App/Store';
import { ChannelEnum } from 'modules/auth/types/LoginRequest';

import gatesApi from './service';
import { getGateMFAData } from './selectors';

interface BeginAndSendGateMFAParams {
  phoneNumber: string;
  dealerId: string;
  channel: ChannelEnum;
  language: string;
}

export const beginAndSendGateMFA = createAsyncThunk(
  'gates/beginAndSendMFA',
  async ({ phoneNumber, dealerId, channel, language }: BeginAndSendGateMFAParams, { dispatch, getState }) => {
    const beginResult = await dispatch(
      gatesApi.endpoints.beginGateMFA.initiate({ phoneNumber, dealerId })
    ).unwrap();

    const { gateId, connectionId } = beginResult;
    const state = getState() as RootState;
    const existingMfaData = getGateMFAData(state);

    if (existingMfaData?.connectionId === connectionId) {
      return beginResult;
    }

    const sendResult = await dispatch(
      gatesApi.endpoints.sendGateMFA.initiate({
        gateId,
        connectionId,
        phoneNumber,
        channel,
        language,
      })
    ).unwrap();

    return { ...beginResult, ...sendResult };
  }
);
